/* eslint-disable no-restricted-globals */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  withStyles,
  CircularProgress,
  Typography,
  Grid,
  Hidden,
  TextField,
} from '@material-ui/core'
import Button from 'components/theme/Button'
import { Add } from '@material-ui/icons'
import { REQUEST, SUCCESS } from '../../utils/statusConstants'
import { list } from 'actions/data'
import { toggleManagePhonesModal } from 'actions/tasks'
import { toggleAcquireNumberDisplay } from '../../actions/phonenumbers'
import AcquireNumberDisplay from './AcquireNumberDisplay'
import language from 'utils/vast-languagepack'
import Icon from '@mdi/react'
import { mdiPlus } from '@mdi/js'
import styles from './styles'
import ListItem from './ListItem'
import Tooltip from 'components/theme/HelpTooltip.js'
import { DATA_API_URL } from 'utils/AllURLs'
import { update } from 'actions/data'

const updatePreferences = payload => (dispatch, getState) => {
  const preferencesAndAccountID = getState().AccountSettings.preferences
  const preferences = preferencesAndAccountID?.preferences
  const account_id = preferencesAndAccountID?.account_id

  return dispatch(
    update(
      {
        account_id,
        preferences: { ...preferences, sms_double_opt_disclaimer: payload },
      },
      'account/preference',
      '',
      'account/preference',
      'none',
    ),
  )
}

const mapStateToProps = state => ({
  phonenumbers: state.data.phonenumbers
    ? Object.values(state.data.phonenumbers)
    : [],
  loadStatus: state.loadStatus.phonenumbers,
  acquireNumberDisplayed: state.phonenumbers.acquireNumberDisplayed,
  managePhonesModalOpen: state.tasks.addOrEdit.managePhonesModalOpen,
  sms_double_opt_disclaimer:
    state.data?.['account/preference']?.preferences?.sms_double_opt_disclaimer,
  a2p10dlc: Object.values(state.data?.a2p10dlc || {})?.[0],
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      list,
      toggleAcquireNumberDisplay,
      toggleManagePhonesModal,
      updatePreferences,
    },
    dispatch,
  )
}
class ManagePhonesPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: this.props.sms_double_opt_disclaimer || '',
    }

    this.handleChange = this.handleChange.bind(this)
    this.updateMessage = this.updateMessage.bind(this)
  }

  componentDidMount() {
    this.props.list('phonenumbers')
    this.props.list('user', 'user_name') // does this even work?
    // this.props.list(
    //   'twilioService/services',
    //   'sid',
    //   `${DATA_API_URL}/twilioService/services`,
    // )
    this.props
      .list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
      .then(a2p10dlcPayload => {
        console.log(a2p10dlcPayload)
        if (!a2p10dlcPayload?.response?.length) {
          console.log('!a2p10dlcPayload?.response?.length')
          // set some sort of state / start creating the object if a bundle exists
        }
      })
  }

  handleChange(event) {
    this.setState({ message: event.target.value })

    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(this.updateMessage, 2000)
  }

  updateMessage() {
    this.props.updatePreferences(this.state.message)
  }

  render() {
    const {
      phonenumbers,
      classes,
      loadStatus,
      toggleAcquireNumberDisplay,
      acquireNumberDisplayed,
      // managePhonesModalOpen,
      // toggleManagePhonesModal,
    } = this.props
    this.confirmDelete = function (d) {
      return window.confirm(d)
    }
    return (
      <div className={classes.main}>
        <Grid justify="space-between" container style={{ marginBottom: 12 }}>
          <Grid item>
            <div className={classes.titleText}>
              PHONE NUMBERS{' '}
              <Tooltip>
                <span>
                  Phone numbers are used to make calls and texts from your
                  account. You can set up a phone number by selecting the{' '}
                  <strong>+ ADD NUMBER</strong> button, then entering an area
                  code in the input box, followed by selecting an available
                  number from the list then clicking the{' '}
                  <strong style={{ color: '#15b940' }}>
                    Green Check Button
                  </strong>{' '}
                  in the number selector.{' '}
                </span>
              </Tooltip>
            </div>
          </Grid>
          <Grid item>
            <Button
              disabled={
                this.props.a2p10dlc &&
                !Object.keys(this.props.a2p10dlc.campaigns || {})?.length
              }
              onClick={() => {
                // if (this.props.a2p10dlcLength) {
                toggleAcquireNumberDisplay()
                // } else {
                //   this.props
                //     .list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
                //     .then(a2p10dlcPayload => {
                //       // console.log('a2p10dlcPayload', a2p10dlcPayload)
                //       if (a2p10dlcPayload?.response?.length) {
                //         toggleAcquireNumberDisplay()
                //       } else {
                //         toggleDialog({
                //           open: true,
                //           dialog: 'A2P10DLC',
                //           options: { possiblyFirst: true },
                //         })
                //       }
                //     })
                // }
              }}
              size="small"
              variant={acquireNumberDisplayed ? 'outlined' : 'contained'}
              color={acquireNumberDisplayed ? 'default' : 'secondary'}
            >
              {acquireNumberDisplayed ? null : <Add />}
              {acquireNumberDisplayed
                ? 'Cancel'
                : language.managePhone.addNumber}
            </Button>
          </Grid>
        </Grid>
        {acquireNumberDisplayed ? (
          <div
            style={{
              marginBottom: 12,
              backgroundColor: '#fff',
              borderRadius: 35,
              padding: 12,
              border: '1px solid gray',
            }}
          >
            <Hidden mdUp>
              <AcquireNumberDisplay missingAreaCodeText="First enter an area code" />
            </Hidden>
            <Hidden smDown>
              <AcquireNumberDisplay missingAreaCodeText="First enter an area code to select a new phone number" />
            </Hidden>
          </div>
        ) : null}
        {loadStatus === SUCCESS && phonenumbers.length ? (
          <div>
            <div className={classes.list}>
              {phonenumbers.map((number, idx) => (
                <ListItem
                  listLength={phonenumbers.length}
                  key={`phonespagephone${idx}`}
                  number={number}
                  idx={idx}
                />
              ))}
            </div>
            <div style={{ marginTop: 20 }}>
              <TextField
                inputProps={{
                  maxLength: 160,
                }}
                multiline
                rowsMax="4"
                label="Customize Your Welcome Message"
                placeholder="Customize the welcome part of your text message here! Keep it friendly and professional."
                fullWidth
                margin="normal"
                // variant="outlined"
                value={this.state.message}
                onChange={this.handleChange}
                helperText={
                  'This will be the first part of the message your contacts ' +
                  'receive when they choose to communicate via text. ' +
                  'It will precede our standard confirmation request, which reads: ' +
                  '"Reply CONFIRM to receive messages from us.  We respect your privacy ' +
                  'and you can reply STOP to opt-out at any time. We will occasionally ' +
                  'send you news and updates for our events and products. Message and data ' +
                  'rates apply."'
                }
              />
            </div>
          </div>
        ) : loadStatus === REQUEST || loadStatus === null ? (
          <CircularProgress className={classes.progress} color="secondary" />
        ) : acquireNumberDisplayed ? null : (
          <Typography variant="h5" gutterBottom>
            <div
              style={{
                textAlign: 'center',
                fontSize: '20px',
                marginTop: '40px',
              }}
            >
              {language.managePhone.noDisplay}
            </div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '20px',
                backgroundColor: '#014c94',
                color: '#ffffff',
                padding: '1%',
                maxWidth: '300px',
                borderRadius: '20px',
                margin: '40px auto 40px auto',
                border: '1px solid black',
                cursor: 'pointer',
                boxShadow:
                  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
              }}
              onClick={() => toggleAcquireNumberDisplay()}
            >
              <Icon path={mdiPlus} size={4} color="white" />
              <br />
              {language.managePhone.addNumber}
            </div>
          </Typography>
        )}
      </div>
    )
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ManagePhonesPage))
